import { render, staticRenderFns } from "./SchemaForm.vue?vue&type=template&id=f512a0b0&scoped=true"
import script from "./SchemaForm.vue?vue&type=script&lang=js"
export * from "./SchemaForm.vue?vue&type=script&lang=js"
import style0 from "./SchemaForm.vue?vue&type=style&index=0&id=f512a0b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f512a0b0",
  null
  
)

export default component.exports